export default __webpack_public_path__ + "static/media/instagram-square-brands.da974473.svg";